import React, { useEffect } from 'react';
import { Col, Row, Select, Input, Form } from 'antd';
import { DeleteFilled } from '@ant-design/icons';

const availablePageRules = [
  {
    value: 'url',
    label: 'URL',
    types: [
      {
        value: 'equals_exactly',
        label: 'equals exactly',
      },
      {
        value: 'equals_simple',
        label: 'equals simple',
      },
      {
        value: 'contains',
        label: 'contains',
      },
      {
        value: 'starts_with',
        label: 'starts with',
      },
      {
        value: 'regexp',
        label: 'matches the regular expression',
      },
    ],
  },
  {
    value: 'path',
    label: 'Path',
    types: [
      {
        value: 'equals_exactly',
        label: 'equals exactly',
      },
      {
        value: 'equals_simple',
        label: 'equals simple',
      },
      {
        value: 'contains',
        label: 'contains',
      },
      {
        value: 'starts_with',
        label: 'starts with',
      },
      {
        value: 'regexp',
        label: 'matches the regular expression',
      },
    ],
  },
  {
    value: 'urlparam',
    label: 'URL Parameter',
    types: [
      {
        value: 'exists',
        label: 'exists',
      },
      {
        value: 'equals_exactly',
        label: 'equals exactly',
      },
      {
        value: 'contains',
        label: 'contains',
      },
      {
        value: 'regexp',
        label: 'matches the regular expression',
      },
    ],
  },
];

const attributeOptions = availablePageRules.map(r => ({
  value: r.value,
  label: r.label,
}));

function getTypeOptions(isSessionRecording, attribute) {
  const rule = availablePageRules.find(r => r.value === attribute);
  return rule?.types.reduce((arr, t) => {
    arr.push(t);
    arr.push({
      value: `not ${t.value}`,
      label: `doesn't ${t.label}`,
    });
    return arr;
  }, isSessionRecording && attribute === 'url' ? [{ value: 'any', label: 'is any' }] : []);
}

const HsrRule = ({ isSessionRecording, field, remove }) => {
  const form = Form.useFormInstance();
  const attribute = Form.useWatch(['rules', field.name, 'attribute']);
  const type = Form.useWatch(['rules', field.name, 'type']);
  const options = getTypeOptions(isSessionRecording, attribute);

  useEffect(() => {
    if (options?.length > 0 && !options.find(o => o.value === type)) {
      form.setFieldValue(['rules', field.name, 'type'], options[0].value);
    }
  }, [attribute]);

  return (
    <Row key={field.key} gutter={16}>
      <Col span={6}>
        <Form.Item name={[field.name, 'attribute']} rules={[{ required: true }]}>
          <Select options={attributeOptions} />
        </Form.Item>
      </Col>

      {attribute === 'urlparam' && (
      <Col span={10}>
        <Form.Item name={[field.name, 'value']} rules={[{ required: true, message: 'Required' }]}>
          <Input placeholder="Name of URL parameter" />
        </Form.Item>
      </Col>
      )}
      <Col span={8}>
        <Form.Item name={[field.name, 'type']} rules={[{ required: true, message: 'Required' }]}>
          <Select options={options} />
        </Form.Item>
      </Col>
      {attribute === 'urlparam' && type?.indexOf('exists') === -1 && (
      <Col span={24}>
        <Form.Item name={[field.name, 'value2']} rules={[{ required: true, message: 'Required' }]}>
          <Input suffix={<DeleteFilled className="ant-btn-dangerous" onClick={() => remove(field.name)} />} placeholder="Value to match" />
        </Form.Item>
      </Col>
      )}
      {attribute !== 'urlparam' && type !== 'any' && (
      <Col span={10}>
        <Form.Item name={[field.name, 'value']} rules={[{ required: true, message: 'Required' }]}>
          <Input suffix={<DeleteFilled className="ant-btn-dangerous" onClick={() => remove(field.name)} />} placeholder="Value to match" />
        </Form.Item>
      </Col>
      )}
    </Row>
  );
};

export default HsrRule;
